module.exports = __webpack_public_path__ + "static/img/4.f65bc21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/4.jpg
// module id = 5On5
// module chunks = 2